import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { onlyRecipe } from '../constants/only-recipe.constant';
import { checkStatusReverse } from './check-status-reverse.handle';

export const checkApproveRecipe = (products) => {
	const countryOnlyRecipe = onlyRecipe[Enviroment.LANGUAGE];
	const rejectedRecipe = 'RI';

	const recipeProducts = products?.filter((product) => countryOnlyRecipe[product.prescryption_type]);
	const result = recipeProducts?.filter((product) => product.validation_product === undefined || product.validation_product === rejectedRecipe);
	if (result.length > 0 && checkStatusReverse(result)) {
		return false;
	}
	return true;
};



